module.exports = __webpack_public_path__ + "img/IMG_8951.d5b3cdaf.jpg";